import { IBaseLayer } from 'shared';

interface BaseMap {
  id: number;
  real_url: string;
  title: string;
  type: string;
  sublayers: BaseMap[];
  size: number;
  layers: string;
  maxNativeZoom: number;
}

export class Utils {
  static createBaseLayerObject(item: BaseMap): IBaseLayer {
    return {
      id: item.id,
      url: item.real_url,
      name: item.title,
      tileSize: item.size,
      layers: item.layers,
      type: item.type,
      isBaseMap: true,
      sublayers: item.sublayers ? item.sublayers.map(data => this.createBaseLayerObject(data)) : [],
      maxNativeZoom: item.maxNativeZoom,
      geojson: null
    };
  }
}
